import { render } from "./terms_page.vue?vue&type=template&id=19f4e7c6&scoped=true"
const script = {}

import "./terms_page.vue?vue&type=style&index=0&id=19f4e7c6&lang=stylus&scoped=true"

import exportComponent from "/Users/v.hirenko/Desktop/DevHubVault/Projects/Techss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f4e7c6"]])

export default __exports__